export enum WhitelistStatus {
  Undefined = 0,
  Created = 1,
  Sent = 2,
  Confirmed = 3,
  Canceled = 4
}